
import { useAuth } from '../../context/AuthContext';
import { LogOut, User, Menu } from 'lucide-react';

import LanguageSwitcher from '../LanguageSwitcher';
import LocalServerUpdateButton from '../common/LocalServerUpdateButton';
import LicenseExpiryBanner from '../common/LicenseExpiryBanner';
import LocalServerDownloadMenu from '../common/LocalServerDownloadMenu';
import MobileApkDownloadButton from '../common/MobileApkDownloadButton';

interface HeaderProps {
    onMenuToggle: () => void;
}

export default function Header({ onMenuToggle }: HeaderProps) {
    const { user, logout } = useAuth();

    return (
        <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 sm:px-6 fixed top-0 right-0 left-0 md:left-64 z-10 shadow-sm">
            <button
                onClick={onMenuToggle}
                className="md:hidden p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md"
                aria-label="Toggle menu"
            >
                <Menu size={20} />
            </button>

            <div className="flex items-center gap-3 ml-auto">
                <LicenseExpiryBanner />
                <LocalServerUpdateButton />
                <LocalServerDownloadMenu />
                <MobileApkDownloadButton />
                <LanguageSwitcher />
                <div className="h-6 w-px bg-gray-200 mx-1 hidden sm:block"></div>
                <div className="flex items-center gap-2">
                    <div className="h-8 w-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-medium flex-shrink-0">
                        {user?.first_name ? user.first_name[0].toUpperCase() : <User size={18} />}
                    </div>
                    <div className="text-sm hidden sm:block">
                        <p className="font-medium text-gray-700">{user?.first_name || 'Admin'} {user?.last_name || ''}</p>
                        <p className="text-xs text-gray-500 capitalize">{user?.role || 'Role'}</p>
                    </div>
                </div>
                <button
                    onClick={logout}
                    className="p-2 ml-1 text-gray-400 hover:text-red-500 transition-colors rounded-full hover:bg-red-50"
                    title="Logout"
                >
                    <LogOut size={20} />
                </button>
            </div>
        </header>
    );
}
